const colors = {
    black: '#000000',
    color1: '#222222',
    color2: '#555555',
    color3: '#CFA22E',
    darkGray: '#929292',
    basketGray: '#909090',
    darkerGray: '#737373',
    green: 'rgb(135, 38, 53)',
    lightGreen: 'rgb(135, 38, 53)',
    header: '#F8F8F8',
    lightGray: '#F3F0F0',
    midGray: '#333333',
    warning: '#EB5757',
    lightWarning: 'rgba(235, 87, 87, 0.20)',
    white: '#FFFFFF',
    basketInfoIcon: 'rgba(34, 34, 34, 0.54)',
    buttonPrimaryColor: '#E30513',
}

export default colors
